export default __webpack_public_path__ + "static/media/2420_2424 front.f218ac05.jpg";